<template>
    <div class="mediaMain">
        <loader v-if="mediaLoading"/>
        <h4>Scanned Documents</h4>
        <div>
            <v-client-table :data="mediaGridSpec.tableData" :columns="mediaGridSpec.columns" :options="mediaGridSpec.options">
                <template slot="download" slot-scope="props">
                    <div style="text-align: center;">
                        <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(props.row.scantoolMediaId, props.row.filename)"></a>
                    </div>
                </template>
            </v-client-table>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import scantoolMediaService from '../services/scantoolMediaService'
import mediaService from '../services/mediaService'
import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    name: 'media',
    props: {
        investigationId: { required: true },
        loadOnMount: { default: true }
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            mediaGridSpec: {
                columns: ['download', 'filename', 'dbNumber', 'revNo', 'acno', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        filename: 'Filename',
                        dbNumber: 'DBI',
                        revNo: 'Rev No',
                        acno: 'ACNO',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'createdDate'
                    }
                }
            },
            mediaRefreshIntervalId: null,
            mediaRefreshCount: 0
        }
    },
    computed: {
        componentName: function () {
            return 'ScantoolMedia ' + this._uid
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted ' + this._uid)
        loggingService.log(this.isDebug, this.componentName, 'mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

        if (this.loadOnMount) this.loadMedia()
    },
    methods: {
        loadMedia () {
            loggingService.log(this.isDebug, this.componentName, 'loadMedia, investigationId: ' + this.investigationId)

            if (this.investigationId) {
                this.mediaLoading = true

                scantoolMediaService.list(this.$http, this.investigationId).then(response => {
                    this.mediaGridSpec.tableData = response.data
                    this.mediaLoading = false
                })
            }
        },
        mediaDownloadRow (scantoolMediaId, filename) {
            loggingService.log(this.isDebug, this.componentName, 'mediaDownloadRow - scantoolMediaId: ' + scantoolMediaId)

            scantoolMediaService.get(this.$http, scantoolMediaId).then(response => {
                mediaService.saveFileToDownload(response, filename)
            })
        }
    }
}
</script>



<style>
    .mediaMain {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 5px;
        background-color: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// ScantoolMedia.vue?78126774